import apidocumentopagarweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apidocumentopagarweb.get('documentopagar', { params: { ...where, ...params } }),
        apidocumentopagarweb.get('documentopagar/count', { params: where }),
      ]);

      return { data, total };
    },

    async findDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apidocumentopagarweb.get('documentopagar/distinct', { params: where }),
      ]);
      return { data };
    },

    async findCardTotal(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apidocumentopagarweb.get('documentopagar/resumo/total', { params: where }),
      ]);
      return { data };
    },

    async findDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apidocumentopagarweb.get(`documentopagar/distinct/${codigo}`),
      ]);
      return { data };
    },

    async findResumoPessoa(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apidocumentopagarweb.get('documentopagar/resumo/pessoa', { params: { ...where, ...params } }),
        apidocumentopagarweb.get('documentopagar/count', { params: where }),
      ]);

      return { data, total };
    },

    async findResumoDate(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apidocumentopagarweb.get('documentopagar/resumo/dia', { params: { ...where, ...params } }),
        apidocumentopagarweb.get('documentopagar/count', { params: where }),
      ]);

      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apidocumentopagarweb.get('documentopagar');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apidocumentopagarweb.get(`documentopagar/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
